export const LAUNCH_DATA_TYPE_UPCOMING = "UPCOMING"
export const LAUNCH_DATA_TYPE_PAST = "PAST"

export const LAUNCH_PAGE_CONTEXT_MISSION_GALERY = "Misson Gallery";
export const LAUNCH_PAGE_CONTEXT_CREW = "Crew";
export const LAUNCH_PAGE_CONTEXT_PAYLOAD = "Payloads";
export const LAUNCH_PAGE_CONTEXT_ROCKET = "Rocket";
export const LAUNCH_PAGE_CONTEXT_CORES = "Cores";
export const LAUNCH_PAGE_CONTEXT_LAUNCHPAD = "Launchpad";
export const LAUNCH_PAGE_CONTEXT_LANDINGZONE = "Landingzone";
export const LAUNCH_PAGE_CONTEXT_SHIPS = "Ships";
export const LAUNCH_PAGE_CONTEXT_TELEMETRY = "Telemetry";

export const SEARCH_LAUNCH = "Launches";
export const SEARCH_CORES = "Cores";
export const SEARCH_SHIP = "Ships";
export const SEARCH_CREW = "Crew";
export const SEARCH_LAUNCHPAD = "Launchpads";
export const SEARCH_ROCKET = "Rockets";

export const LAUNCHES_CORE = "core"
export const LAUNCHES_SHIP = "ship"
export const LAUNCHES_UPCOMING = "upcoming";
export const LAUNCHES_PAST = "past";
export const LAUNCHES_ALL = "all";
export const LAUNCHES_CREW = "crew";
export const LAUNCHES_LAUNCHPAD = "launchpad";
export const LAUNCHES_ROCKET = "rocket";